module.exports = __webpack_public_path__ + "img/Ruvimbo Dzvurumi.eb91b075.jpg";